// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.common-footer {
  background: #061a3a;
  color: #ede7f6;
  padding: 56px 0 22px;
}

.common-footer__inner {
  width: min(1080px, 92%);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.35fr 1fr 1fr 1fr;
  gap: 44px;
}

.common-footer__logo-slot {
  width: 130px;
  height: 140px;
  border-radius: 12px;
  object-fit: contain;
  display: block;
  margin-bottom: 10px;
}

.common-footer__brand-block p {
  margin: 0;
  max-width: 280px;
  color: #d6c8dd;
  font-size: 1rem;
  line-height: 1.55;
}

.common-footer__contact {
  margin-top: 24px;
}

.common-footer h4 {
  margin: 0;
  font-size: 2rem;
  color: #ffffff;
  font-weight: 700;
}

.common-footer__contact p {
  margin: 8px 0 0;
  color: #c2afcc;
  font-size: 0.96rem;
}

.common-footer ul {
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 10px;
}

.common-footer a {
  color: #e8def1;
  text-decoration: none;
  font-size: 0.95rem;
}

.common-footer a:hover {
  color: #ffffff;
  text-decoration: underline;
}

.common-footer__socials {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.common-footer__socials a {
  border: none;
  padding: 0;
  font-size: 1.02rem;
  font-weight: 700;
  text-transform: none;
}

.common-footer__bottom {
  width: min(1080px, 92%);
  margin: 26px auto 0;
  padding-top: 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.16);
}

.common-footer__bottom p {
  margin: 0;
  text-align: center;
  font-size: 0.96rem;
  color: #b5a2bf;
}

.call-float,
.whatsapp-float {
  position: fixed;
  right: 18px;
  z-index: 1300;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #ffffff;
  border-radius: 999px;
  padding: 8px 14px 8px 8px;
  text-decoration: none;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.22);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.call-float {
  bottom: 82px;
  background: #0f5cc0;
}

.whatsapp-float {
  bottom: 20px;
  background: #25d366;
}

.call-float:hover,
.whatsapp-float:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.26);
}

.call-float__icon,
.whatsapp-float__icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  overflow: hidden;
}

.call-float__icon-image,
.whatsapp-float__icon-image {
  width: 22px;
  height: 22px;
  object-fit: contain;
  display: block;
}

.call-float__text,
.whatsapp-float__text {
  display: inline-flex;
  flex-direction: column;
  line-height: 1.15;
}

.call-float__text strong,
.whatsapp-float__text strong {
  font-size: 0.88rem;
}

.call-float__text small,
.whatsapp-float__text small {
  font-size: 0.77rem;
}

@media (max-width: 820px) {
  .common-footer {
    padding-top: 22px;
  }

  .common-footer__inner {
    grid-template-columns: 1fr;
    gap: 26px;
  }

  .common-footer h4 {
    font-size: 1.35rem;
  }

  .common-footer a {
    font-size: 1rem;
  }

  .common-footer__brand-block p,
  .common-footer__contact p,
  .common-footer__bottom p,
  .common-footer__socials a {
    font-size: 0.96rem;
  }

  .common-footer__logo-slot {
    width: 112px;
    height: 122px;
  }

  .call-float,
  .whatsapp-float {
    right: 12px;
    padding: 8px 12px 8px 8px;
    gap: 8px;
  }

  .call-float {
    bottom: 74px;
  }

  .whatsapp-float {
    bottom: 14px;
  }

  .call-float__icon,
  .whatsapp-float__icon {
    width: 34px;
    height: 34px;
  }

  .call-float__text strong,
  .whatsapp-float__text strong {
    font-size: 0.82rem;
  }

  .call-float__text small,
  .whatsapp-float__text small {
    font-size: 0.72rem;
  }
}
`, "",{"version":3,"sources":["webpack://./components/layout.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,yCAAyC;EACzC,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;EAC3C,qDAAqD;AACvD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;IAIE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;;IAEE,WAAW;IACX,yBAAyB;IACzB,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;EACpB;AACF","sourcesContent":[".common-footer {\n  background: #061a3a;\n  color: #ede7f6;\n  padding: 56px 0 22px;\n}\n\n.common-footer__inner {\n  width: min(1080px, 92%);\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1.35fr 1fr 1fr 1fr;\n  gap: 44px;\n}\n\n.common-footer__logo-slot {\n  width: 130px;\n  height: 140px;\n  border-radius: 12px;\n  object-fit: contain;\n  display: block;\n  margin-bottom: 10px;\n}\n\n.common-footer__brand-block p {\n  margin: 0;\n  max-width: 280px;\n  color: #d6c8dd;\n  font-size: 1rem;\n  line-height: 1.55;\n}\n\n.common-footer__contact {\n  margin-top: 24px;\n}\n\n.common-footer h4 {\n  margin: 0;\n  font-size: 2rem;\n  color: #ffffff;\n  font-weight: 700;\n}\n\n.common-footer__contact p {\n  margin: 8px 0 0;\n  color: #c2afcc;\n  font-size: 0.96rem;\n}\n\n.common-footer ul {\n  margin: 12px 0 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: 10px;\n}\n\n.common-footer a {\n  color: #e8def1;\n  text-decoration: none;\n  font-size: 0.95rem;\n}\n\n.common-footer a:hover {\n  color: #ffffff;\n  text-decoration: underline;\n}\n\n.common-footer__socials {\n  margin-top: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n}\n\n.common-footer__socials a {\n  border: none;\n  padding: 0;\n  font-size: 1.02rem;\n  font-weight: 700;\n  text-transform: none;\n}\n\n.common-footer__bottom {\n  width: min(1080px, 92%);\n  margin: 26px auto 0;\n  padding-top: 18px;\n  border-top: 1px solid rgba(255, 255, 255, 0.16);\n}\n\n.common-footer__bottom p {\n  margin: 0;\n  text-align: center;\n  font-size: 0.96rem;\n  color: #b5a2bf;\n}\n\n.call-float,\n.whatsapp-float {\n  position: fixed;\n  right: 18px;\n  z-index: 1300;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: #ffffff;\n  border-radius: 999px;\n  padding: 8px 14px 8px 8px;\n  text-decoration: none;\n  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.22);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.call-float {\n  bottom: 82px;\n  background: #0f5cc0;\n}\n\n.whatsapp-float {\n  bottom: 20px;\n  background: #25d366;\n}\n\n.call-float:hover,\n.whatsapp-float:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.26);\n}\n\n.call-float__icon,\n.whatsapp-float__icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #ffffff;\n  overflow: hidden;\n}\n\n.call-float__icon-image,\n.whatsapp-float__icon-image {\n  width: 22px;\n  height: 22px;\n  object-fit: contain;\n  display: block;\n}\n\n.call-float__text,\n.whatsapp-float__text {\n  display: inline-flex;\n  flex-direction: column;\n  line-height: 1.15;\n}\n\n.call-float__text strong,\n.whatsapp-float__text strong {\n  font-size: 0.88rem;\n}\n\n.call-float__text small,\n.whatsapp-float__text small {\n  font-size: 0.77rem;\n}\n\n@media (max-width: 820px) {\n  .common-footer {\n    padding-top: 22px;\n  }\n\n  .common-footer__inner {\n    grid-template-columns: 1fr;\n    gap: 26px;\n  }\n\n  .common-footer h4 {\n    font-size: 1.35rem;\n  }\n\n  .common-footer a {\n    font-size: 1rem;\n  }\n\n  .common-footer__brand-block p,\n  .common-footer__contact p,\n  .common-footer__bottom p,\n  .common-footer__socials a {\n    font-size: 0.96rem;\n  }\n\n  .common-footer__logo-slot {\n    width: 112px;\n    height: 122px;\n  }\n\n  .call-float,\n  .whatsapp-float {\n    right: 12px;\n    padding: 8px 12px 8px 8px;\n    gap: 8px;\n  }\n\n  .call-float {\n    bottom: 74px;\n  }\n\n  .whatsapp-float {\n    bottom: 14px;\n  }\n\n  .call-float__icon,\n  .whatsapp-float__icon {\n    width: 34px;\n    height: 34px;\n  }\n\n  .call-float__text strong,\n  .whatsapp-float__text strong {\n    font-size: 0.82rem;\n  }\n\n  .call-float__text small,\n  .whatsapp-float__text small {\n    font-size: 0.72rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
